import React, { useState } from 'react'
import ImageInput from 'components/shared/ImageInput'
import api from 'api/api'
import styles from 'components/modals/image-update.module.scss'
import { PurpleButton } from 'components/shared/buttons/Button'
import {
    AVATAR_IMAGE_ACCEPT,
    AVATAR_IMAGE_ERROR,
    isAvatarImageFile,
} from 'components/users/avatarUpload'

export default function UserImageUpdate({ modalParams, closeModal }) {
    const { user } = modalParams

    const avatarUrl = `${window.knovApiUrl}/api/v1/users/${user.id}/avatar?size=large`

    const [{ alt, src }, setImg] = useState({
        src: user.user_image_url ? avatarUrl : '',
        alt: 'No Image',
    })
    const [selectedFile, setSelectedFile] = useState(false)
    const [uploadError, setUploadError] = useState('')

    const handleSubmit = async ev => {
        ev.preventDefault()
        ev.stopPropagation()

        const form = new FormData(ev.target)
        const file = form.get('user_image')
        if (!isAvatarImageFile(file)) {
            setUploadError(AVATAR_IMAGE_ERROR)
            return
        }

        const data = await api.updateUser(user.id, form)
        if (data?.user) {
            modalParams.callback(data.user)
            closeModal()
            return
        }

        setUploadError(data?.errors?.join(' ') || AVATAR_IMAGE_ERROR)
    }

    const handleImage = ev => {
        const file = ev.target.files[0]
        if (!file) return

        if (!isAvatarImageFile(file)) {
            ev.target.value = ''
            setSelectedFile(false)
            setUploadError(AVATAR_IMAGE_ERROR)
            return
        }

        setSelectedFile(true)
        setUploadError('')
        setImg({
            src: URL.createObjectURL(file),
            alt: file.name,
        })
    }

    return (
        <div className={styles.userImageUpdateComp}>
            <form
                className={styles.userImageUpdateForm}
                method="PATCH"
                onSubmit={handleSubmit}
                encType="multipart/form-data"
            >
                <ImageInput
                    src={src}
                    alt={alt}
                    name="user_image"
                    handleImg={handleImage}
                    accept={AVATAR_IMAGE_ACCEPT}
                    label="Profile Picture"
                    contextStyles={styles.userImageInput}
                />

                {uploadError && (
                    <div className={styles.uploadError} role="alert">
                        {uploadError}
                    </div>
                )}

                <div className={styles.submitImageBtnContainer}>
                    <button
                        type="submit"
                        disabled={!selectedFile}
                        style={{ border: 'none', background: 'none', padding: 0 }}
                    >
                        <PurpleButton text="Submit" disabled={!selectedFile} />
                    </button>
                </div>
            </form>
        </div>
    )
}
